<div class="container">
    <div class="row">
        <div class="col-md-8 mr-auto ml-auto">
            <h2 class="title">{{'reserves.myWallet'|traduccion}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <div class="float-left"></div>
                    <div class="float-right"></div>
                </div>
                <div class="card-body">


                    <mat-card class="invoicing-card">
                    
                        <div class="header-grid">
                            <div class="header-item">
                                <h4>{{'myWallet.balance.title'|traduccion}}</h4>
                                <p class="amount">{{wallet.balance|currency: 'EUR'}}</p>
                                <small class="info"><mat-icon>info</mat-icon> {{'myWallet.balance.info'|traduccion}}</small>
                            </div>

                             <div class="header-item">
                                <h4>{{'myWallet.lastPurchase.title'|traduccion}}</h4>
                                <p class="amount">{{ (wallet.lastMovement?.amount || 0)|currency: 'EUR'}}</p>
                                <p>{{wallet.lastMovement?.description|traduccion}}</p>
                            </div>
                                        
                            <div class="header-item enquiries">
                                <h4>{{'myWallet.movements.title'|traduccion}}</h4>
                                <button mat-raised-button color="primary" (click)="openInvoiceDialog()">
                                    {{'myWallet.movements.button'|traduccion}}
                                </button>
                            </div>
                        </div>
                    
                    
                    </mat-card>

                    <h2>{{'myWallet.coupons.buy'|traduccion}}</h2>
                    <ng-container *ngIf="(coupons | keyvalue).length > 0; else noCoupons">
                        <div *ngFor="let couponKeyValue of coupons | keyvalue" class="coupon-location-group">
                            <h3 class="coupon-location-title">{{couponKeyValue.key}}</h3>
                            <div class="coupons-grid">
                                <mat-card *ngFor="let coupon of couponKeyValue.value" class="coupon-card">
                                    <mat-card-header>
                                        <mat-card-title>{{coupon.description}}</mat-card-title>
                                    </mat-card-header>

                                    <mat-card-content>
                                        <p class="price">{{ coupon.price | currency:'EUR' }}</p>
                                    </mat-card-content>

                                    <mat-card-actions>
                                        <button mat-raised-button color="primary" (click)="buyMyDiscountCoupon(coupon)">{{'myWallet.coupons.exchange'|traduccion}}</button>
                                    </mat-card-actions>
                                </mat-card>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noCoupons>
                        <div class="no-data">
                            {{'myWallet.coupons.noData'|traduccion}}
                        </div>
                    </ng-template>


                    <h2>{{'myWallet.discount.myDiscounts'|traduccion}}</h2>
                    <div class="coupons-grid discounts">
                        <mat-card *ngFor="let discount of discounts" class="coupon-card" [class.disabled]="discount.disabled">
                            <mat-card-header>
                                <mat-card-title>{{'myWallet.discount.code'|traduccion}}: {{ discount.code }}</mat-card-title>
                            </mat-card-header>

                            <mat-card-content>
                                <p>{{showDescriptionCoupons(discount.description)}}</p>
                                <p class="price" *ngIf="discount.discountType=='AMOUNT'">-{{ discount.discount|currency:'EUR' }}</p>
                                <p class="price" *ngIf="discount.discountType=='PERCENTAGE'">-{{ discount.discount }}%</p>
                                <p>{{discount.location.name}}</p>
                                <small class="info"><mat-icon>info</mat-icon> {{'myWallet.discount.info'|traduccion}}</small>
                            </mat-card-content>

                        </mat-card>
                        <!-- Mensaje sin datos -->
                        <div class="no-data" *ngIf="discounts.length === 0">
                            {{'myWallet.discount.noData'|traduccion}}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
